export default "__VITE_ASSET__93847eaf__"